import(/* webpackMode: "eager" */ "/app/app/(home)/auth/fastregister/page.tsx");
